import { Theme as MuiTheme, createTheme, adaptV4Theme } from '@mui/material/styles';

export interface Theme extends MuiTheme {
	sidebar: {
		width: number;
		widthCollapsed: number;
		background: string;
		color: string;
	};
	header: {
		background: string;
	};
}

const baseTheme = createTheme({
	components:{
		MuiAppBar:{
			styleOverrides:{
				root:{
					elevation:1
				}
			}
		},
		MuiButton:{
			styleOverrides:{
				root:{
					minWidth: 0
				}
			}
		},
		MuiPaper:{
			styleOverrides:{
				root:{
					elevation:1
				}
			}
		},
	},
	palette: {
		secondary: {
			main: '#e4e5e6', //indigo[600],
		},
		primary: {
			main: '#042630', //'#619f30',
			light: '#ffffff',	//added for testing
      dark:'#000000',
		},
	},
	typography: {
		h1: {
			fontSize: '2rem',
		},
		h2: {
			fontSize: '1.8rem',
		},
		h3: {
			fontSize: '1.6rem',
		},
		h4: {
			fontSize: '1.4rem',
		},
		h5: {
			fontSize: '1.2rem',
		},
		h6: {
			fontSize: '1rem',
		},
	},
});

const adminTheme = {
	header: {
		background: '#fff',
	},
	sidebar: {
		width: 255,
		widthCollapsed: baseTheme.spacing(5),
		background: '#02272F;',
		color: '#fff',
	},
};

const theme = {
	...baseTheme,
	...adminTheme,
};

export default theme;
